@if (items?.length) {
  <button
    rippleEffect
    type="button"
    class="btn btn-outline-primary d-block w-100"
    (click)="selectAll()">
    Alle auswählen
  </button>
}
